type Day = {
	uuid: string;
	label: string;
	value: string;
};

export const days: Day[] = [
	{
		uuid: "a07da978-46ff-40a6-8b0f-5ba5685f710f",
		label: "Sunday",
		value: "SUNDAY",
	},
	{
		uuid: "a07da978-4708-4f31-a3eb-f45a5d9c556f",
		label: "Monday",
		value: "MONDAY",
	},
	{
		uuid: "a07da978-470a-429d-9e4a-c48bf6c307fb",
		label: "Tuesday",
		value: "TUESDAY",
	},
	{
		uuid: "a07da978-470c-4bf1-a7af-b30171c46624",
		label: "Wednesday",
		value: "WEDNESDAY",
	},
	{
		uuid: "a07da978-470e-4741-9b29-bf414c5bc376",
		label: "Thursday",
		value: "THURSDAY",
	},
	{
		uuid: "a07da978-470f-450d-9e50-d868a748d616",
		label: "Friday",
		value: "FRIDAY",
	},
	{
		uuid: "a07da978-4710-4de7-8120-f45a39d2d963",
		label: "Saturday",
		value: "SATURDAY",
	},
];
